import {StyledHomepage} from './StyledHomepage';
import Header from '../Header/Header';
import Main from '../Main/Main';
import Footer from '../Footer/Footer';

function Homepage() {
  return (
    <StyledHomepage>
        <Header/>
        <Main/>
        <Footer/>
    </StyledHomepage>
  );
}

export default Homepage;
